module.exports = __webpack_public_path__ + "img/close-homework.02237fa4.svg";